import { useMutation } from "@apollo/client";
import React from "react";
import { CHANGE_PASSWORD } from "../../../../graphql/queries";
import toast from 'react-hot-toast'
import ChangePassword from "./ChangePassword";

const ChangePasswordPage = () => {
  const [changePassword] = useMutation(CHANGE_PASSWORD)

  /** @type {import("./types").ChangePasswordFn} */
  const _onSubmit = async (oldPassword, newPassword) => {
    try {
      await changePassword({ variables: { oldPassword, newPassword } })
      toast.success('Your password has been changed')
      return true
    } catch (error) {
      console.error(JSON.stringify(error))
      const errMsg = error.networkError?.result?.errors?.[0]?.message || 'An error has occurred. Please try again.'
      toast.error(errMsg)
      return false
    }
  }

  return <ChangePassword onSubmit={_onSubmit} />
}

export default ChangePasswordPage